import { DesignSystem } from "../design-system.js";
import { DropdownOptionStyles, DropdownOptionTemplate } from "@fluentui/web-components";
import { DropdownOption } from "./option.js";
/**
 * The Fabric Option Element definition.
 *
 * @public
 * @remarks
 * HTML Element: `<fabric-option>`
 */
export const definition = DropdownOption.compose({
    name: `${DesignSystem.prefix}-option`,
    template: DropdownOptionTemplate,
    styles: DropdownOptionStyles,
    shadowOptions: {
        delegatesFocus: true
        // No slotAssignment needed for option based on temp implementation
    }
});
//# sourceMappingURL=option.definition.js.map